import { map } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Observable } from "rxjs";

@Injectable()
export class FileService {
    private defaultHeaders = new HttpHeaders().set(
        "Content-Type",
        "application/json; charset=utf-8"
    );

    constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

    getImageFromBlobUrl(url: string): Observable<any> {
        return this.http
            .get(url, {
                responseType: "text",
                observe: "response",
                headers: this.defaultHeaders,
            })
            .pipe(
                map((res) => {
                    const contentType = res.headers.get("content-type");
                    const blob = new Blob([res.body], { type: contentType });
                    const fileUrl = window.URL.createObjectURL(blob);

                    return this.sanitizer.bypassSecurityTrustUrl(fileUrl);
                })
            );
    }
}
